var React = require('react');

function Cl (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h682.7v512H0z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"scale(.9375)","key":1},[React.createElement("path",{"fill":"#fff","d":"M256 0h512v256H256z","key":0}),React.createElement("path",{"fill":"#0039a6","d":"M0 0h256v256H0z","key":1}),React.createElement("path",{"fill":"#fff","d":"M167.8 191.7L128.2 162l-39.5 30 14.7-48.8L64 113.1l48.7-.5L127.8 64l15.5 48.5 48.7.1-39.2 30.4 15 48.7z","key":2}),React.createElement("path",{"fill":"#d52b1e","d":"M0 256h768v256H0z","key":3})])]);
}

Cl.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cl;

Cl.default = Cl;
